<template>
  <div class=" ">
    <!-- auth Actions -->
    <slot />
    <div class="flex justify-center space-x-2 -mt-1" v-if="isActive">
      <button
        @click="cancelSubscription"
        class="sub-btn-bg text-white text-center rounded-md md:py-1 md:px-8 px-4 py-2 md:text-[1.2vw] text-[12px] truncate"
      >
        إلفاء الإشتراك
      </button>

      <button
        @click="logout"
        class="border border-color text-white text-center rounded-md md:py-1 md:px-8 px-4 py-2 md:text-[1.2vw] text-[12px] truncate"
      >
        تسجيل خروج
      </button>
    </div>
    <div class="flex justify-center space-x-2 -mt-1" v-else>
      <router-link to="/auth/mobily/subscribe">
        <button
          class="sub-btn-bg text-white text-center rounded-md md:py-1 md:px-8 px-4 py-2 md:text-[1.2vw] text-[12px] truncate"
        >
          اشترك الان
        </button>
      </router-link>

      <router-link to="/auth/mobily/login">
        <button
          class="border border-color text-white text-center rounded-md md:py-1 md:px-8 px-4 py-2 md:text-[1.2vw] text-[12px] truncate"
        >
          تسجيل دخول
        </button>
      </router-link>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from "@/stores/auth";
import { mapActions } from "pinia";
import { useToast } from "vue-toastification";

export default {
  components: {
  },
  data() {
    return {
      user: false,
      isActive: false,
      isDone: false,
      toast: useToast()
    };
  },
  async mounted() {
    await this.chechIsDoneAction();
    await this.checkIsActiveAction();
  },
  watch: {
    // eslint-disable-next-line
    isActive(newValue, oldValue) {},
  },
  methods: {
    async chechIsDoneAction() {
      return (this.isDone = localStorage.getItem("isDone"));
    },
    async checkIsActiveAction() {
      return (this.isActive = localStorage.getItem("isActive") === "true");
    },
    ...mapActions(useAuthStore, ["unsubscribe"]),
    // Check success instead of checking the raw message
    async cancelSubscription() {
    

      window.location.href = "http://infomob.digitalcg.net/";
    },
    redirectUser(response) {
      if (response.data.success == true) {
    
        this.isActive = false;

        this.toast.success("تم إلغاء الإشتراك بنجاح");
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        localStorage.removeItem("key");
        localStorage.removeItem("isActive");
        this.$router.push({ name: "home" });
      } else {
        this.toast.error("حدث خطأ أثناء إلغاء الإشتراك. حاول مرة أخرى.");
        setTimeout(() => {
          this.$router.push({ name: "home" });
        }, 1200);
      }
        
      
    },
    logout() {
      if (
        window.localStorage.getItem("user") ||
        window.localStorage.getItem("isActive")
      ) {
        window.localStorage.removeItem("user");
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("key");
        window.localStorage.removeItem("isActive");
        this.isActive = false;
        this.toast.success("تم تسجيل الخروج بنجاح");
        setTimeout(() => {
          this.$router.push({ name: "home" });
        }, 1500);
      }
    },
  }, //end of methods
};
</script>

<style></style>
